import type { useTransitionStatus } from '@floating-ui/react';

export const OVERLAY_TRANSITION_DURATION_MS = 250;

export type TransitionStatusType = ReturnType<typeof useTransitionStatus>['status'];
